import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import moment from "moment";

const RecordDGIIInfo = (props: { rnc: string }) => {
    const { rnc } = props;
    const [record, setRecord] = useState<any>(null);
    const { t } = useTranslation();

    const bindRecord = async () => {
        try {
            const response = await API.getAction(`DGII/Contribuyentes?rnc=${rnc}`);
            if (response.status === 200 && response.data.status === "ok") {
                const data = response.data.response;
                if (Array.isArray(data) && data.length > 0) {
                    setRecord(data[0]);
                }
            }
        } catch (error) {
            // silent fail
        }
    };

    useEffect(() => {
        if (rnc) bindRecord();
    }, [rnc]);

    if (!record) return null;

    return (
        <Card className="my-4">
            <Card.Header className="display-4">
                {t("Información DGII")}
            </Card.Header>
            <Card.Body className="p-4">
                <Row>
                    <Col xs={12} md={6}>
                        <b className="me-2">RNC</b>
                        {record.rnc ?? record.RNC}
                        <br />
                        <b className="me-2">{t("Nombre")}</b>
                        {record.nombre ?? record.Nombre}
                        <br />
                        <b className="me-2">{t("Régimen")}</b>
                        {record.regimen ?? record.Regimen ?? "-"}
                    </Col>
                    <Col xs={12} md={6}>
                        <b className="me-2">{t("Estatus")}</b>
                        <span className={`badge ${record.estatus === "ACTIVO" || record.Estatus === "ACTIVO" ? "bg-success" : "bg-secondary"}`}>
                            {record.estatus ?? record.Estatus ?? "-"}
                        </span>
                        <br />
                        <b className="me-2">{t("Fecha Constitución")}</b>
                        {(record.fechaConstitucion ?? record.FechaConstitucion)
                            ? moment(record.fechaConstitucion ?? record.FechaConstitucion).format("DD/MM/YYYY")
                            : "-"}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default RecordDGIIInfo;
